module.exports = __webpack_public_path__ + "static/logo-fd4c1acfe399e8c038f833a3210c41b4.jpeg";